import { io } from 'socket.io-client';

let socket = null;
const eventos = [];

const createEvents = () => {
    eventos.forEach((event) => {
        socket.on(event.eventName, event.callback);
    });
};

const createSocket = (store) => {
    if (socket == null && store.getters['Auth/getToken'] !== undefined) {
        socket = io(process.env.VUE_APP_SOCKET_SERVICE, {
            extraHeaders: {
                'x-token': store.getters['Auth/getToken'],
            },
            reconnection: true, // Habilita la reconexión automática
            reconnectionAttempts: Infinity, // Número máximo de intentos de reconexión (Infinity para ilimitados)
            reconnectionDelay: 1000, // Tiempo de espera inicial en ms entre intentos
            reconnectionDelayMax: 5000, // Tiempo máximo de espera entre intentos
            randomizationFactor: 0.5, // Factor de randomización para el retraso entre intentos
        });
        socket.on('connect', () => {
            // const { engine } = socket.io;
            // console.log(engine.transport.name); // in most cases, prints "polling"
            // engine.on('packet', ({ type, data }) => {
            //     // called for each packet received
            //     console.log('packet');
            //     console.log({ type, data });
            // });
        });
        socket.on('auth_error', async (errorData) => {
            console.error(
                'Error de autenticación desde el servidor (evento custom):',
                errorData.message
            );
            if (errorData.type === 'TokenExpiredError') {
                console.warn('¡El token ha expirado! Se requiere refresco o re-login.');
                await store.dispatch('Auth/doRefreshToken');
                const newToken = store.getters['Auth/getToken'];
                if (newToken) {
                    socket.disconnect();
                    socket = null;
                    createSocket(store);
                }
            } else if (
                errorData.type === 'JsonWebTokenError' ||
                errorData.type === 'NoTokenProvided'
            ) {
                console.error('Token inválido o faltante. Redirigiendo a login.');
            } else {
                console.error('Otro error de autenticación:', errorData.message);
            }

            if (socket.connected) {
                socket.disconnect();
                socket = null;
            }
        });
        socket.on('connect_error', (error) => {
            console.error('Error de conexión (Socket.IO default):', error.message);
        });
        createEvents();
    }
    return socket;
};

const addEvent = (eventName, callback) => {
    eventos.push({ eventName, callback });
    socket.on(eventName, callback);
};

const destroySocket = () => {
    socket.disconnect();
    socket = null;
};

const useSocket = () => ({
    socket,
    addEvent,
    createSocket,
    destroySocket,
});

export default useSocket;
